/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Builder_Prop_Show_QrInputs */

const cs_builder_prop_show_qr = /** @type {(inputs: Builder_Prop_Show_QrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zobrazit QR`)
};

const en_builder_prop_show_qr = /** @type {(inputs: Builder_Prop_Show_QrInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show QR`)
};

/**
* | output |
* | --- |
* | "Show QR" |
*
* @param {Builder_Prop_Show_QrInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const builder_prop_show_qr = /** @type {((inputs?: Builder_Prop_Show_QrInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Builder_Prop_Show_QrInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_builder_prop_show_qr(inputs)
	return cs_builder_prop_show_qr(inputs)
});